import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const input = this.element.querySelector('input[type="file"]');
        const label = this.element.querySelector('label');
        const defaultText = label.innerHTML;

        input.addEventListener('change', () => {
            if (input.files.length > 0) {
                label.innerHTML = Array.from(input.files).map(file => file.name).join(', ');
            } else {
                label.innerHTML = defaultText;
            }
        });
    }
}
